import { LanguageProvider } from '@/context/LanguageContext';
import Navbar from '@/components/site/Navbar';
import Hero from '@/components/site/Hero';
import WhoWeAre from '@/components/site/WhoWeAre';
import CapabilitiesIntro from '@/components/site/CapabilitiesIntro';
import Capabilities from '@/components/site/Capabilities';
import Research from '@/components/site/Research';
import Partnerships from '@/components/site/Partnerships';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';

export default function Landing() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#0A1128] text-white">
        <Navbar />
        <main>
          <Hero />
          <WhoWeAre />
          <CapabilitiesIntro />
          <Capabilities />
          <Research />
          <Partnerships />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
